import {
  Card,
  CardProps,
  Stack,
  StackProps,
  Typography,
  Box,
} from '@mui/material';
import { HeroMetric, HeroMetricProps } from './HeroMetric';
import { DARK_GRAY_COLOR } from '@utils/colorGenerator';

type HeroMetricsCardProps = {
  title: string;
  metrics: HeroMetricProps[];
  sx?: CardProps['sx'];
  justifyContent?: StackProps['justifyContent'];
};

export const HeroMetricsCard = (props: HeroMetricsCardProps) => {
  return (
    <Card sx={{ padding: '1rem', ...props.sx }}>
      <Stack direction="column" spacing="1rem">
        <Typography color={DARK_GRAY_COLOR}>{props.title}</Typography>

        <Stack
          direction="row"
          gap="1.5rem"
          flexWrap="wrap"
          justifyContent={props.justifyContent ?? 'space-between'}
        >
          {props.metrics.map(metric => (
            <Box key={metric.label} sx={{ flexGrow: 1 }}>
              <HeroMetric {...metric} />
            </Box>
          ))}
        </Stack>
      </Stack>
    </Card>
  );
};
